export default __webpack_public_path__ + "static/media/challenge3.92b76c78.jpg";